import React from 'react'
import { JsonViewer } from '../../../../../../../common/JsonViewer.jsx'
import { HeaderTitle } from '../../../../../../../common/HeaderTitle.jsx'
import RadioWiz from '../../../../../../../common/inputs/wizard/RadioWiz.jsx'
import { KontaktRepeater } from '../../common/parts/KontaktRepeater.jsx'
import { optionsTakNie } from '../../../../../../../utils/options.js'

const Kontakt = (props) => {
    const wiz = props.wiz
    const form = wiz?.form || {}
    const isNie = form.kontakt_z_kp === 'Nie'

    return (
        <div>
            <JsonViewer src={form} show={false} />
            <HeaderTitle noHr size={'fs-3'} title={'E. Osoba do kontaktu - sporządzająca sprawozdanie'} />

            <div className="d-flex flex-column gap-3 mt-3">
                <RadioWiz
                    wiz={wiz}
                    keyName={'kontakt_z_kp'}
                    label={wiz.getLabel('kontakt_z_kp')}
                    options={optionsTakNie}
                />

                {isNie && (
                    <KontaktRepeater wiz={wiz} parentListName="kontakt_list" />
                )}
            </div>
        </div>
    )
}

export default Kontakt
